import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, PreloadingStrategy, Route, Router } from '@angular/router';
import { filter, map, Observable, of } from 'rxjs';

export enum PreloadCheckpoints {
  ADMIN = 'ADMIN'
}

@Injectable({
  providedIn: 'root'
})
export class PreloadingStrategyService implements PreloadingStrategy {

  preloadedModules: string[] = []
  checkpoints: Set<PreloadCheckpoints> = new Set<PreloadCheckpoints>();

  constructor(router: Router, route: ActivatedRoute) {

    router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => route),
      map(route => {
        while (route.firstChild) route = route.firstChild; //gets the deepest child
        return route;
      }),
      filter(route => route.outlet === 'primary'))
      .subscribe((route) => {
        if (route.snapshot.data['preloadCheckpoint'] !== undefined) {
          this.checkpoints.add(route.snapshot.data['preloadCheckpoint']);
        }
      });
  }

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (route.data && route.data['preload']) {
      this.preloadedModules.push(route.path)
      route.children?.forEach(child => {
        if (child.data.preloadAfterCheckpoint && this.checkpoints.has(route.data['preloadAfterCheckpoint'])) child.loadChildren()
      })
      return load()
    } else {
      return of(null)
    }

  }

}
